import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@ui/primitives';
import { useRef, useState } from 'react';
export function WithTooltip(param) {
    let { name, showName = true, children, onClick, styleBold = true } = param;
    const [showTooltip, setShowTooltip] = useState(false);
    const ellipsisRef = useRef(null);
    const onMouseOver = ()=>{
        const target = ellipsisRef.current;
        if (target && target.offsetWidth < target.scrollWidth) {
            setShowTooltip(true);
        }
    };
    const onMouseLeave = ()=>{
        setShowTooltip(false);
    };
    return /*#__PURE__*/ _jsx("div", {
        className: styleBold ? 'flex items-center font-semibold' : 'flex items-center',
        onClick: onClick,
        children: /*#__PURE__*/ _jsx(TooltipProvider, {
            children: /*#__PURE__*/ _jsxs(Tooltip, {
                open: showTooltip,
                children: [
                    /*#__PURE__*/ _jsx(TooltipTrigger, {
                        asChild: true,
                        children: /*#__PURE__*/ _jsxs("span", {
                            ref: ellipsisRef,
                            className: "overflow-hidden text-ellipsis whitespace-nowrap",
                            onMouseOver: onMouseOver,
                            onMouseLeave: onMouseLeave,
                            children: [
                                showName && name,
                                children
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(TooltipContent, {
                        children: /*#__PURE__*/ _jsx("p", {
                            children: name
                        })
                    })
                ]
            })
        })
    });
}
